<button [ngStyle]="buttonStyles" (click)="emitClick()">
  <div class="shade"></div>
  @if (icon) {
    <mat-icon [svgIcon]="icon" />
  }
  <span>{{ label }}</span>
</button>
